import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { Images } from "./../../assets/common";
import moment from "moment";
import { truncate } from "../../constants/function";
import { useTranslation } from "react-i18next";
export default function Notification({
  notification,
  onclick,
  openChat,
  getPlaylistDetail,
}) {
  const { t } = useTranslation("common");
  const handleClick = (path) => {
    if (path)
      onclick(
        path,
        notification["_id"],
        notification["status"] === "seen" ? true : false
      );
    else if (notification["type"] === "tip_recieved") {
      onclick(
        `/app/Wallet`,
        notification["_id"],
        notification["status"] === "seen" ? true : false
      );
    } else if (notification["type"] === "livestream_started")
      getPlaylistDetail(notification["channelName"]);
    else if (notification["type"] === "create_wallet") {
      onclick(`/app/Wallet`);
    } else if (notification["type"] === "message_sent") openChat(true);
  };

  return (
    <Box
      title={
        notification["type"] === "livestream_started"
          ? t("openStream")
          : notification["type"] === "create_wallet"
          ? t("openWallet")
          : ""
      }
      sx={{
        padding: "8px 21px",
        backgroundColor: `${
          notification["status"] === "seen" ? "#1E1E1E" : "#FFFFFF05"
        }`,
        cursor: "pointer",
      }}
      onClick={() => handleClick()}
    >
      <Stack direction="row" alignItems="center">
        <Box className="avatar">
          <img
            style={{
              width: "44px",
              height: "44px",
              borderRadius:
                notification["type"] === "livestream_started" ? "0" : "50%",
              objectFit: notification["type"] === "message_sent" ? "none" : "",
            }}
            src={
              notification["type"] === "tip_recieved"
                ? notification?.currency === "siki"
                  ? Images.coin
                  : notification?.currency === "hbar"
                  ? Images.hbar
                  : notification?.currency === "matic"
                  ? Images.polygon
                  : Images.coin
                : notification["type"] === "bid_placed_playlist" ||
                  notification["type"] === "bid_placed_music" ||
                  notification["type"] === "NFT Sale" ||
                  notification["type"] === "received_royalties"
                ? Images.bid
                : notification["type"] === "new_subscriber" ||
                  notification["type"] === "token_limit_request" ||
                  notification["type"] === "user_whitelisted"
                ? Images.royalty
                : notification["type"] === "flag_asset"
                ? Images.flag
                : notification["type"] === "premium_renewal_stopped" ||
                  notification["type"] === "premium_renewed"
                ? Images.subscription
                : notification["type"] === "message_sent"
                ? Images.chat
                : notification["type"] === "livestream_started"
                ? Images.streaming
                : notification["type"] === "create_wallet"
                ? Images.wallet
                : notification["iconImg"]
            }
            alt="icon"
          />
        </Box>
        <Stack
          sx={{
            marginLeft: "12px",
            cursor:
              notification["type"] === "livestream_started"
                ? "pointer"
                : "default",
          }}
          spacing={1}
        >
          <p
            style={{
              fontSize: "14px",
              lineHeight: "20px",
              cursor:
                notification["type"] === "livestream_started" ||
                notification["type"] === "create_wallet"
                  ? "pointer"
                  : "default",
            }}
          >
            {notification["type"] === "new_follower" ||
            notification["type"] === "music_uploaded" ||
            notification["type"] === "message_sent"
              ? null
              : notification["body"]}{" "}
            {!notification["body"] ? (
              <span
                title={t("viewArtist")}
                style={{
                  fontSize: "14px",
                  cursor: "pointer",
                  color:
                    notification["type"] === "flag_asset"
                      ? "#e3293e"
                      : "#FFEE20",
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  if (notification["type"] === "flag_asset")
                    handleClick(
                      `/app/ArtistProfile/${notification["referenceId"]}`
                    );
                }}
              >
                {notification["title"]}
              </span>
            ) : null}
            {notification["type"] === "message_sent"
              ? "New message from "
              : null}
            <span
              title="View artist profile"
              style={{ fontSize: "14px", color: "#FFEE20", cursor: "pointer" }}
              onClick={(e) => {
                e.stopPropagation();
                handleClick(
                  `/app/ArtistProfile/${
                    notification["type"] === "livestream_started"
                      ? notification["artistId"]
                      : notification["referenceId"]
                  }`
                );
              }}
            >
              {notification["name"]}
            </span>
            {notification["type"] === "message_sent" ? <br /> : null}
            {notification["type"] === "new_follower" ||
            notification["type"] === "music_uploaded" ||
            notification["type"] === "message_sent"
              ? notification["type"] === "message_sent"
                ? truncate(notification["body"], 40)
                : notification["body"]
              : null}{" "}
          </p>
          <Typography
            sx={{
              fontSize: "11.5px",
              color: "#707070",
              marginTop: "0 !important",
            }}
          >
            {moment(notification["createdDate"]).fromNow()}
          </Typography>
        </Stack>
      </Stack>
    </Box>
  );
}
